module.exports = __webpack_public_path__ + "img/037-storm-7.50f46504.svg";